'use client';

import { useEffect } from 'react';

export function LogRocketProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Defer LogRocket initialization to reduce main thread blocking
    // Use requestIdleCallback for browsers that support it, otherwise setTimeout
    const initLogRocket = () => {
      // Dynamic import to reduce initial bundle size
      import('logrocket').then((LogRocket) => {
        LogRocket.default.init('hniabp/andrew-mccourt');
      });
    };

    if (typeof window !== 'undefined') {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(initLogRocket, { timeout: 3000 });
      } else {
        // Fallback: delay initialization by 2 seconds
        setTimeout(initLogRocket, 2000);
      }
    }
  }, []);

  return <>{children}</>;
}
